import { Component, OnInit, OnDestroy, inject } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-offline',
  standalone: true,
  imports: [],
  templateUrl: './offline.component.html',
  styleUrl: './offline.component.css',
})
export class OfflineComponent implements OnInit, OnDestroy {
  private router = inject(Router);
  private onlineHandler?: () => void;
  private ngxSpinnerService = inject(NgxSpinnerService);

  constructor(private dialog: MatDialog) {}

  ngOnInit(): void {
    this.dialog.closeAll();
    this.ngxSpinnerService.hide();
    // Listen for online event
    this.onlineHandler = () => {
      this.handleOnline();
    };
    window.addEventListener('online', this.onlineHandler);

    // Also check if already online when component loads
    if (navigator.onLine) {
      this.handleOnline();
    }
  }

  ngOnDestroy(): void {
    // Clean up event listener
    if (this.onlineHandler) {
      window.removeEventListener('online', this.onlineHandler);
    }
  }

  retry(): void {
    if (navigator.onLine) {
      this.handleOnline();
    } else {
      window.location.reload();
    }
  }

  private handleOnline(): void {
    // Get the last route before going offline
    const lastRoute = localStorage.getItem('lastRouteBeforeOffline');

    if (lastRoute) {
      // Remove the stored route
      localStorage.removeItem('lastRouteBeforeOffline');
      // Redirect to the last route
      this.router.navigateByUrl(lastRoute);
    } else {
      // If no last route stored, redirect to main dashboard
      this.router.navigate(['/main']);
    }
  }
}
